(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TicketPaymentDetailController', TicketPaymentDetailController);

    TicketPaymentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TicketPayment', 'Passenger', 'Customer'];

    function TicketPaymentDetailController($scope, $rootScope, $stateParams, previousState, entity, TicketPayment, Passenger, Customer) {
        var vm = this;

        vm.ticketPayment = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:ticketPaymentUpdate', function(event, result) {
            vm.ticketPayment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
